import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalBodyFn = /* @__PURE__ */ createRecipe('modal-body', {}, [])

const modalBodyVariantMap = {}

const modalBodyVariantKeys = Object.keys(modalBodyVariantMap)

export const modalBody = /* @__PURE__ */ Object.assign(memo(modalBodyFn.recipeFn), {
  __recipe__: true,
  __name__: 'modalBody',
  __getCompoundVariantCss__: modalBodyFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: modalBodyVariantKeys,
  variantMap: modalBodyVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalBodyVariantKeys)
  },
  getVariantProps: modalBodyFn.getVariantProps,
})